import axios from "axios";
import moment from "moment";
import { getXRFHeaderValue } from "../utils/getXRFHeaderValue";

import AbstractPathService from './AbstractPathService';

const mapId = "%7B68E713D8-A382-4378-8FB0-9D7F7AD14B25%7D";
const dateFormat = "YYYYMMDDT000000";

class PathService extends AbstractPathService {
  getItemPaths(itemid, start, end) {
    const startDate = moment(start).format(dateFormat);
    const endDate = moment(end).format(dateFormat);
    // console.log(`loading PA data: ${startDate} | ${endDate}`);
    const serviceUri = `/sitecore/api/PathAnalyzer/tree?treeDefinitionId=${mapId}&start=${startDate}&end=${endDate}&language=en&group=%7B00000000-0000-0000-0000-000000000000%7D&filter=${itemid}`;
    const options = {
      headers: {
        "content-type": "application/json",
        "X-RequestVerificationToken": getXRFHeaderValue(),
        "X-Requested-With": "XMLHttpRequest"
      },
      withCredentials: true
    };

    return axios
      .get(serviceUri, options)
      .then(res => res.data)
      .catch(error => { });
  }
}

export default new PathService();



// WEBPACK FOOTER //
// ./src/data/PathService.prod.js